import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';
import * as fromState from './state';

export const reducer = createReducer(
  fromState.initialState,
  on(fromActions.moveRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.moveSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(fromActions.moveFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(fromActions.resetState, () => fromState.initialState),
);

export function virtualChannelReducer(
  state: fromState.State | undefined,
  action: Action,
) {
  return reducer(state, action);
}
